import { render, staticRenderFns } from "./LogTab.vue?vue&type=template&id=36076259&scoped=true"
import script from "./LogTab.vue?vue&type=script&lang=js"
export * from "./LogTab.vue?vue&type=script&lang=js"
import style0 from "./LogTab.vue?vue&type=style&index=0&id=36076259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36076259",
  null
  
)

export default component.exports